import { lazy } from 'react';

const RedeemEarnPopupComponent = lazy(() => import('./RedeemEarnForm.container'));

const RedeemEarnPopup = (id: string | number, currency?: string) => ({
  component: <RedeemEarnPopupComponent id={id} currency={currency} />,
  wrapperClassName: 'redeem-earn-popup',
  useBottomSheet: true,
  hideCloseIcon: false,
  closeOnClickOutside: true,
});

export default RedeemEarnPopup;
